import React, { createContext, useState, useCallback } from 'react';
import axios from 'axios';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const login = (user) => {
    setUser(user); // Update user state when user logs in
  };

  const logout = useCallback(() => {
    localStorage.removeItem("isha_token"); // You might also want to remove the token from localStorage when logging out
    setUser(null); // Set user state to null when user logs out
  }, []);

  const updateUser = useCallback(async () => {
    setIsLoading(true);
    const token = localStorage.getItem("isha_token");
    const config = {
      headers: { Authorization: `${token}` },
    };

    try {
      const response = await axios.get('/api/user', config);
      setUser(response.data.user);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, isLoading, login, logout, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};
